import { getSubProductPending,getMainSubProductPending, getMainSubProductSuccess ,getMainSubProductFail,getSubProductSuccess, getSubProductFail, 
    deleteSubProductPending, deleteSubProductSuccess, deleteSubProductFail,
    getSSubProductPending, getSSubProductSuccess, getSSubProductFail, 
    createSubProductPending, createSubProductSuccess, createSubProductFail, 
    modifySubProductPending, modifySubProductSuccess, modifySubProductFail,reset,
    imageUploadFailure,imageUploadSuccess,deleteSubProductImageFail,deleteSubProductImagePending,deleteSubProductImageSuccess,getSubProductImageFail,getSubProductImagePending,getSubProductImageSuccess,getSSubProductImageFail,getSSubProductImagePending,getSSubProductImageSuccess,modifySubProductImageFail,modifySubProductImagePending,modifySubProductImageSuccess
} from "./subproductSlice";
import { fetchAllSubProduct,fetchAllMainSubProduct, subproductDelete,  subproductCreation, subproductModify, fetchSingleSubProduct,fetchAllSubProductImage,subproductImageDelete,fetchSingleSubProductImage,subproductImageModify} from "../../../api/userApi";
import Swal from "sweetalert2";
export const getAllSubProduct = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getSubProductPending());
        const result = await fetchAllSubProduct();
        console.log("prodddd",result)
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

       // console.log('allSubProductData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const SubProductdetails = JSON.parse(JSON.stringify(myObj.subproducts));
        const SubProductdetails1 = JSON.parse(JSON.stringify(SubProductdetails));
      // console.log('SubProductdetails ' + SubProductdetails);
       //console.log( SubProductdetails);
        if (SubProductdetails) {
        
            return dispatch(getSubProductSuccess(SubProductdetails));
        }
        dispatch(getSubProductFail("SubProduct is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getSubProductFail(err.msg));

    }
}


export const getAllMainSubProduct = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getMainSubProductPending());
        const result = await fetchAllMainSubProduct();
        console.log("prodddd",result)
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

       // console.log('allSubProductData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const SubProductdetails = JSON.parse(JSON.stringify(myObj.subproducts2));
        const SubProductdetails1 = JSON.parse(JSON.stringify(SubProductdetails));
      // console.log('SubProductdetails ' + SubProductdetails);
       //console.log( SubProductdetails);
        if (SubProductdetails) {
        
            return dispatch(getMainSubProductSuccess(SubProductdetails));
        }
        dispatch(getMainSubProductFail("SubProduct is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getSubProductFail(err.msg));

    }
}



export const subproductDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteSubProductPending());
        const result = await subproductDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteSubProductSuccess("SubProduct deleted"))
        : dispatch(deleteSubProductFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteSubProductFail(err.msg));
    }
    
}




export const newSubProductCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createSubProductPending());
        const result = await subproductCreation(frmDt);
        console.log('myresult',result)
        console.log(result);
        result.status === "success"
            ? dispatch(createSubProductSuccess(result.result1.id))
            : dispatch(createSubProductFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        console.log(error);
        //  if(error.response.status===401){}
        const err = JSON.parse(JSON.stringify(error.response.data.error));
       //  console.log(err);
        // console.log('disp');
        // console.log(err.msg);
       
       const row = err.map((er, i) => {
        //console.log('loop');
        //console.log(er.msg);
        //console.log('loop param');

        //console.log(er.param);
            if (i === er.length - 1) {
              return er.param+' '+er.msg+'. ';
            }
            return er.param+' '+er.msg+'\n ';
          });
          //console.log('row');
          //console.log(row);
          dispatch(createSubProductFail(row));
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
       
       
       
    }

}

export const getSingleSubProduct = (id) => async (dispatch) => {
    
 
 console.log('service id : '+id);
    try {
     //call the api
    dispatch(getSSubProductPending());
    const result = await fetchSingleSubProduct(id);
   // const userData=JSON.parse(result.user);
 console.log('moshiiii ');
 //console.log(result);
 console.log("122",result);
 
 //console.log('check user profile out if');
    if(result.subproducts[0] && result.subproducts[0].id){
    //console.log('check user profile');
        return dispatch(getSSubProductSuccess(result.subproducts[0]));
    }
    dispatch(getSSubProductFail("Sub Product is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
    console.log(err.msg);
    dispatch(getSSubProductFail(err.msg));
 
 }
    
 
 }








export const SubProductModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifySubProductPending());
        const result = await subproductModify(frmDt);
        console.log("result",result)
        result.status === "success"
            ? dispatch(modifySubProductSuccess(result.message))
            : dispatch(modifySubProductFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        // console.log("cattttttttt")
        // Swal.fire({
        //     title: 'Error!',
        //     text: 'This SubProduct exist with another record',
        //     icon: 'error',
        //     confirmButtonText: 'Close'
        //   })
  
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifySubProductFail(err.msg));
    }

}
export const getAllSubProductImage = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getSubProductImagePending());
        const result = await fetchAllSubProductImage();
        console.log("prodddssssd",result)
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

       // console.log('allProductData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const productdetails = JSON.parse(JSON.stringify(myObj.subproduct));
        const productdetails1 = JSON.parse(JSON.stringify(productdetails));
      // console.log('Productdetails ' + productdetails);
       //console.log( productdetails);
        if (productdetails) {
        
            return dispatch(getSubProductImageSuccess(productdetails));
        }
        dispatch(getSubProductImageFail("Product image is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getSubProductFail(err.msg));

    }
}

export const subproductImageDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteSubProductImagePending());
        const result = await subproductImageDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteSubProductImageSuccess("Sub Product Image deleted"))
        : dispatch(deleteSubProductImageFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteSubProductImageFail(err.msg));
    }
    
}


export const getSingleSubProductImage = (id) => async (dispatch) => {
    
 
       try {
        //call the api
       dispatch(getSSubProductImagePending());
       const result = await fetchSingleSubProductImage(id);
       console.log("resttttt",result)

       const myJSON = JSON.stringify(result);

        const myObj = JSON.parse(myJSON);
        const productdetails = JSON.parse(JSON.stringify(myObj.product));

       if(productdetails){
  
           return dispatch(getSSubProductImageSuccess(productdetails));
       }
       dispatch(getSSubProductImageFail("Product Image is not found"));
    
      
    } catch (error) {

       const err = JSON.parse(JSON.stringify(error.response.data.error));

       console.log(err.msg);
       dispatch(getSSubProductFail(err.msg));
    
    }
       
    
    }


export const imageUploadFailureProcess = (msg) => async (dispatch) => {
    try {

        dispatch(imageUploadFailure(msg));
    }
    catch{


    }
}
export const imageuploadProcess = (msg) => async (dispatch) => {
    try {

        dispatch(imageUploadSuccess(msg));
    }
    catch{


    }
}

export const subproductImageModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifySubProductImagePending());
        const result = await subproductImageModify(frmDt);
        console.log("result",result)
        result.status === "success"
            ? dispatch(modifySubProductImageSuccess(result.message))
            : dispatch(modifySubProductImageFail(result.message));

     
    } catch (error) {
       
  
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifySubProductImageFail(err.msg));
    }

}


export const resetSubProductCreatiion = () => async (dispatch) => {
    try {

        dispatch(reset());
    }
    catch{


    }
}





